var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    clipPath: "url(#clip0_1865_3382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.5417 3.83322H3.83341C3.32508 3.83322 2.83757 4.03516 2.47813 4.3946C2.11868 4.75405 1.91675 5.24156 1.91675 5.74989V19.1666C1.91675 19.6749 2.11868 20.1624 2.47813 20.5218C2.83757 20.8813 3.32508 21.0832 3.83341 21.0832H17.2501C17.7584 21.0832 18.2459 20.8813 18.6054 20.5218C18.9648 20.1624 19.1667 19.6749 19.1667 19.1666V12.4582M17.7292 2.39572C18.1105 2.01448 18.6276 1.80029 19.1667 1.80029C19.7059 1.80029 20.223 2.01448 20.6042 2.39572C20.9855 2.77697 21.1997 3.29406 21.1997 3.83322C21.1997 4.37239 20.9855 4.88948 20.6042 5.27072L11.5001 14.3749L7.66675 15.3332L8.62508 11.4999L17.7292 2.39572Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1865_3382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.8d1f1eaafa0e7b1f06def4d5c7bb2e85.svg";
export { ForwardRef as ReactComponent };